import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { BasePageComponent } from '../../base-page';
import { IPageData } from 'src/app/interfaces/page-data';
import { Spinkit } from 'ng-http-loader';
import { Subject } from 'rxjs';
import { IAppState } from 'src/app/interfaces/app-state';
import { Router, ActivatedRoute } from '@angular/router';
import { MatBottomSheet, MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { HttpService } from 'src/app/services/http/http.service';
import { Store } from '@ngrx/store';
import * as PageActions from '../../../store/actions/page.actions';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import { IOption } from 'src/app/ui/interfaces/option';
import swal from 'sweetalert2'
import { element } from 'protractor';
@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent extends BasePageComponent implements OnInit, OnDestroy {
  pageData: IPageData;
  public spinkit = Spinkit;
  restoID
  ids
  UserCondition
  token
  tableids
  clickmydetail: boolean = false
  clickfood: boolean = false
  editDetails: boolean = true
  fileData: File = null;
  User_details
  public totalSubject = new Subject()
  public orderSubject = new Subject()
  messageFilesize: string;
  imageFile: any;
  currentAvatar
  defalutimage ='./assets/img/PngItem_1503945.png'
  errorMessage;
  up_fname
  up_lname
  up_gender
  feet
  load:boolean = false;
  up_inch
  email
  is_facebook
  is_google
  up_phone
  up_address
  up_profile_image
  user_preferences = []
  user_preference_spice
  user_ingredients = []
  allAllergens = []
  alldietary = []
  algns = []
  dietPref = []
  ingredients_arry = []
  spicevalue = [];
  ingredientbind = []
  userDislikes = []
  userDislikesbind = []
  userDietary = []
  userAllergens = []
  dietaryarry = []
  allergensarry = []
  backtolocation = '0'
  message = "click to select"

  data = [
    { "label": "Man", "value": "Man" },
    { "label": "Woman", "value": "Woman" },
    { "label": "Non-Binary", "value": "Non-Binary" },
    { "label": "Don't wish to disclose", "value": "Don't wish to disclose" }
  ]


  datas = [
    { "label": "1", "value": "1" },
    { "label": "2", "value": "2" },
    { "label": "3", "value": "3" },
    { "label": "4", "value": "4" }
  ]
  datafeet = [
    { "label": "1", "value": "1" },
    { "label": "2", "value": "2" },
    { "label": "3", "value": "3" },
    { "label": "4", "value": "4" },
    { "label": "5", "value": "5" },
    { "label": "6", "value": "6" },
    { "label": "7", "value": "7" },
    { "label": "8", "value": "8" }
  ]

  datainch = [
    { "label": "1", "value": "1" },
    { "label": "2", "value": "2" },
    { "label": "3", "value": "3" },
    { "label": "4", "value": "4" },
    { "label": "5", "value": "5" },
    { "label": "6", "value": "6" },
    { "label": "7", "value": "7" },
    { "label": "8", "value": "8" },
    { "label": "9", "value": "9" },
    { "label": "10", "value": "10" },
    { "label": "11", "value": "11" },
    { "label": "12", "value": "12" },
  ]


  userIngredients
  taste_code: any;
  details_profile: string;
  preferences_profile: string;

  constructor(store: Store<IAppState>,
    public httpSv: HttpService, private router: Router,
    private route: ActivatedRoute, private _bottomSheet: MatBottomSheet) {
    super(store, httpSv);
    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: '',
          route: 'editprofile'
        }
      ]
    };
  }


  ngOnInit() {
    this.restoID = sessionStorage.getItem("restoId")
    this.token = sessionStorage.getItem('access_token')
    this.ids = sessionStorage.getItem('restoIds')
    this.tableids = sessionStorage.getItem('tableIds')
    this.details_profile = sessionStorage.getItem('Details')
    this.preferences_profile = sessionStorage.getItem('preferences')
    this.route.queryParams.subscribe(params => {
      this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    });
    this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;

    if (this.UserCondition) {
      this.userProfileDetails();
      this.getfoodPreferences();
      this.getIngredients();
      // this.getallAllergens();
      this.getallDiestpref();
      this.tasteDetailsget();

      this.allAllergens.forEach(element => {
        this.algns.push(element.allergens_id)
      });

      this.alldietary.forEach(element => {
        this.dietPref.push(element.diet_preference_id)
      });
      this.user_ingredients.forEach(element => {
        this.ingredients_arry.push(element.sub_ingredient_id)
      })

    }

if(this.details_profile){
  this.onclickmydetail();
}
if(this.preferences_profile){
  this.onclickfood();
}

  }

  ngOnDestroy() {
    this.store.dispatch(new PageActions.Reset());
  }

  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], {
            queryParams: {
              id: this.ids,
              table_id: this.tableids
            }
          });
        } else {
          Swal.fire("Something Went Wrong")
        }
      }
    )
  }

  onclickmydetail() {
    this.clickmydetail = true
    this.editDetails = false
    this.backtolocation = '1'
  }

  onclickfood() {
    this.clickfood = true
    this.editDetails = false
    this.backtolocation = '1'
  }



 
  fileChange(event) {
    let fileList: FileList = event.target.files;
  }

  onImageChange(event) {
    if (event.target.files && event.target.files[0]) {
      const fsize = event.target.files[0].size;
      const fileSize = Math.round((fsize / 1024));
      if (fileSize < 2048) {
        this.imageFile = new FormData();
        this.imageFile.append('file', event.target.files[0]);
        let file: File = event.target.files[0];
        let reader: FileReader = new FileReader();
        this.messageFilesize = ""
        reader.onloadend = () => {
          this.currentAvatar = reader.result;
        };
        reader.readAsDataURL(file);
      }
      else {
        this.messageFilesize = "File too Big, please select a file less than 2mb"
      }
    }

  }


  uploadImage() {
    this.httpSv.updateuserImage(this.imageFile).subscribe(
      response => {
        if (response['status'] == true) {

        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
        else if (err.status == 500) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
      }
    )
  }

  userProfileDetails() {
    this.httpSv.userProfileDetails().subscribe(res => {
      if (res['status'] == true) {
        this.User_details = res['result']
        this.up_fname = res['result'].up_fname
        this.up_lname = res['result'].up_lname
        this.up_gender = res['result'].up_gender
        this.feet = res['result'].feet
        this.up_inch = res['result'].up_inch
        this.email = res['result'].email
        this.is_facebook = res['result'].is_facebook 
        this.is_google = res['result'].is_google 
        this.up_phone = res['result'].up_phone
        this.up_address = res['result'].up_address
        this.currentAvatar = res['result'].up_profile_image
      }
    })
  }

  updateProfile(up_fname, up_lname, up_phone, up_gender, up_address, feet, up_inch) {
    this.httpSv.updateUserProfile(up_fname, up_lname, up_phone, up_gender, up_address, feet, up_inch).subscribe(
      response => {
        if (response['status'] == true) {
          swal.fire({
            titleText: response['message'],
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 422) {
          this.errorMessage = err.error.message.fname ? err.error.message.fname : "";
      
          Swal.fire({
            title: this.errorMessage
          }
          );
        }
        if (err.status == 401) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
        else if (err.status == 500) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }

      }
    )
  }

  getfoodPreferences() {
    this.httpSv.getfoodPreferences().subscribe(
      res => {
        if (res['status'] == true) {
          this.user_preferences = res['result']
          this.user_preference_spice = res['result'].user_preference_spice
          this.userIngredients = res['result'].userIngredients
          this.userDislikes = res['result'].userDislikes
          this.userDietary = res['result'].userDietary
          this.is_google = res['result'].is_google 
          this.is_facebook = res['result'].is_facebook 
          this.userAllergens = res['result'].userAllergens
          if (this.userAllergens) {
            this.userAllergens.forEach(element => {
              this.allergensarry.push(element.allergens_id)
            })
          }
          else {
            this.allergensarry = []
          }
          if (this.userDietary) {
            this.userDietary.forEach(element => {
              this.dietaryarry.push(element.diet_preference_id)
            })
          }
          else {
            this.userDietary = []
          }
          if (this.userIngredients) {
            this.userIngredients.forEach(element => {
              this.ingredientbind.push(element.sub_ingredient_id)
            });
          }
          else {
            this.userIngredients = []
          }
          if (this.userDislikes) {
            this.userDislikes.forEach(element => {
              this.userDislikesbind.push(element.sub_ingredient_id)
            });
          }
          else {
            this.userDislikes = []
          }
          this.load = true;
        }
      }
    )
  }
  getIngredients() {
    this.httpSv.getIngredients().subscribe(
      res => {
        if (res['status'] == true) {
          this.user_ingredients = res['result']
        }
      }
    )
  }

  getallDiestpref() {
    this.httpSv.getallDiestpref().subscribe(
      res => {
        if (res['status'] == true) {
          this.alldietary = res['result'].data
        }
      }
    )
  }
  // getallAllergens() {
  //   this.httpSv.getallAllergens().subscribe(
  //     res => {
  //       if (res['status'] == true) {
  //         this.allAllergens = res['result'].data
  //       }
  //     }
  //   )
  // }

  UpdatefoodPreferences(allergensarry, dietPref, ingredientbind, user_preference_spice, userDislikesbind) {
    this.httpSv.foodPreferences(allergensarry, dietPref, ingredientbind, user_preference_spice, userDislikesbind).subscribe(
      res => {
        if (res['status'] == true) {
        }
      }
    )
  }
  onclickmyorders(){
    this.router.navigate(['horizontal/order-list'])
  }
  backtodetails() {
    this.editDetails = true
    this.clickfood = false
    this.clickmydetail = false
    // this.ngOnInit();

    this.router.navigate(['/horizontal/profile'])
    sessionStorage.removeItem("preferences")
    sessionStorage.removeItem("Details")
  }

  tasteDetailsget(){
    this.httpSv.tasteDetailsget().subscribe(res=>{
      if(res['status'] == true){
        this.taste_code = res['result'].data.tc_code
      }
    }, (err: HttpErrorResponse) => {
     if (err.status == 401) {
       this.logout();
     }
     else if (err.status == 500) {
       this.logout();
     }
   })
     }

}


